import Vue from "vue";
import Router from "vue-router";
import { authGuard } from "@/Auth/authGuard";

import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import Landing from "@/pages/Landing.vue";
import Dashboard from "@/pages/dashboard/Dashboard.vue";

import AddConsultant from "@/pages/data-management/consultants/AddConsultant";
import ConsultantList from "@/pages/data-management/consultants/ConsultantList";
import EditConsultant from "@/pages/data-management/consultants/EditConsultant";

import AddContractor from "@/pages/data-management/contractors/AddContractor";
import ContractorList from "@/pages/data-management/contractors/ContractorList";
import ContractorView from "@/pages/data-management/contractors/ContractorView";
import EditContractor from "@/pages/data-management/contractors/EditContractor";
import AddContractorRegion from "@/pages/data-management/contractors/contractor-regions/AddContractorRegion";
import ContractorRegionView from "@/pages/data-management/contractors/contractor-regions/ContractorRegionView";
import EditContractorRegion from "@/pages/data-management/contractors/contractor-regions/EditContractorRegion";
import AddContractorContact from "@/pages/data-management/contractors/contractor-contacts/AddContractorContact";
import EditContractorContact from "@/pages/data-management/contractors/contractor-contacts/EditContractorContact";

import AddClient from "@/pages/data-management/clients/AddClient";
import ClientList from "@/pages/data-management/clients/ClientList";
import ClientView from "@/pages/data-management/clients/ClientView";
import AddClientContact from "@/pages/data-management/clients/client-contacts/AddClientContact";
import EditClientContact from "@/pages/data-management/clients/client-contacts/EditClientContact";
import EditClient from "@/pages/data-management/clients/EditClient";
import AddSite from "@/pages/data-management/clients/sites/AddSite";
import SiteView from "@/pages/data-management/clients/sites/SiteView";
import EditSite from "@/pages/data-management/clients/sites/EditSite";
import AddBuilding from "@/pages/data-management/clients/buildings/AddBuilding";
import BuildingView from "@/pages/data-management/clients/buildings/BuildingView";
import EditBuilding from "@/pages/data-management/clients/buildings/EditBuilding";
import AddPlant from "@/pages/data-management/clients/plants/AddPlant";
import PlantView from "@/pages/data-management/clients/plants/PlantView";
import EditPlant from "@/pages/data-management/clients/plants/EditPlant";

import PlantsWithoutStatInsps from "@/pages/stat-insp/PlantsWithoutStatInsps";
import StatInspByFilter from "@/pages/stat-insp/StatInspFilter";
import StatInspItemFilter from "@/pages/stat-insp/StatInspItemFilter";
import AddStatInsp from "@/pages/stat-insp/stat-insp/AddStatInsp";
import EditStatInsp from "@/pages/stat-insp/stat-insp/EditStatInsp";
import StatInspView from "@/pages/stat-insp/stat-insp/StatInspView";
import NextStatInsp from "@/pages/stat-insp/stat-insp/NextStatInsp";
import AddStatInspItem from "@/pages/stat-insp/stat-insp-item/AddStatInspItem";
import EditStatInspItem from "@/pages/stat-insp/stat-insp-item/EditStatInspItem";
import StatInspItemView from "@/pages/stat-insp/stat-insp-item/StatInspItemView";

import QuotesList from "@/pages/quotes/QuoteListings";
import QuotesCompletedList from "@/pages/quotes/QuoteCompletedListings";
import QuotesRejectedList from "@/pages/quotes/QuoteRejectedListings";
import AddQuote from "@/pages/quotes/AddQuote";
import EditQuote from "@/pages/quotes/EditQuote";
import QuoteView from "@/pages/quotes/QuoteView";
import ReissueQuote from "@/pages/quotes/ReissueQuote";

import ClientListing from "@/pages/portfolio/ClientListing";
import Client from "@/pages/portfolio/Client";
import Site from "@/pages/portfolio/Site";
import Building from "@/pages/portfolio/Building";
import Plant from "@/pages/portfolio/Plant";

import UserListings from "@/pages/users/UserListings";
import AddUser from "@/pages/users/AddUser";
import EditUser from "@/pages/users/EditUser";

Vue.use(Router);

let consultantRoutes = {
  path: "/datamanagement/consultants",
  component: DashboardLayout,
  name: "Consultants Section",
  redirect: "Consultants",
  children: [
    {
      path: "",
      name: "Consultants",
      components: { default: ConsultantList },
      beforeEnter: authGuard
    },
    {
      path: "add-consultant",
      name: "Add Consultant",
      components: { default: AddConsultant },
      beforeEnter: authGuard
    },
    {
      path: ":consultantId/edit",
      name: "Edit Consultant",
      components: { default: EditConsultant },
      beforeEnter: authGuard
    }
  ]
};

let contractorRoutes = {
  path: "/datamanagement/contractors",
  component: DashboardLayout,
  name: "Contractors Section",
  redirect: "Contractors",
  children: [
    {
      path: "",
      name: "Contractors",
      components: { default: ContractorList },
      beforeEnter: authGuard
    },
    {
      path: "add-contractors",
      name: "Add Contractor",
      components: { default: AddContractor },
      beforeEnter: authGuard
    },
    {
      path: ":contractorId",
      name: "Contractor",
      components: { default: ContractorView },
      beforeEnter: authGuard
    },
    {
      path: ":contractorId/edit",
      name: "Edit Contractor",
      components: { default: EditContractor },
      beforeEnter: authGuard
    },
    {
      path: ":contractorId/regions/addRegion",
      name: "Add Contractor Region",
      components: { default: AddContractorRegion },
      beforeEnter: authGuard
    },
    {
      path: ":contractorId/regions/:regionId",
      name: "Contractor Region",
      components: { default: ContractorRegionView },
      beforeEnter: authGuard
    },
    {
      path: ":contractorId/regions/:regionId/edit",
      name: "Edit Contractor Region",
      components: { default: EditContractorRegion },
      beforeEnter: authGuard
    },
    {
      path: ":contractorId/regions/:regionId/contacts/addContact",
      name: "Add Contractor Contact",
      components: { default: AddContractorContact },
      beforeEnter: authGuard
    },
    {
      path: ":contractorId/regions/:regionId/contacts/:contactId/edit",
      name: "Edit Contractor Contact",
      components: { default: EditContractorContact },
      beforeEnter: authGuard
    }
  ]
};

let clientRoutes = {
  path: "/datamanagement/clients",
  component: DashboardLayout,
  name: "Clients Section",
  redirect: "Clients",
  children: [
    {
      path: "",
      name: "Clients",
      components: { default: ClientList },
      beforeEnter: authGuard
    },
    {
      path: "add-client",
      name: "Add Client",
      components: { default: AddClient },
      beforeEnter: authGuard
    },
    {
      path: ":clientId",
      name: "Client",
      components: { default: ClientView },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/edit",
      name: "Edit Client",
      components: { default: EditClient },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/add-client-contact",
      name: "Add Client Contact",
      components: { default: AddClientContact },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/client-contact/:clientContactId/edit",
      name: "Edit Client Contact",
      components: { default: EditClientContact },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/add-site",
      name: "Add Site",
      components: { default: AddSite },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/sites/:siteId",
      name: "Site",
      components: { default: SiteView },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/sites/:siteId/edit",
      name: "Edit Site",
      components: { default: EditSite },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/sites/:siteId/add-building",
      name: "Add Building",
      components: { default: AddBuilding },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/sites/:siteId/buildings/:buildingId",
      name: "Building",
      components: { default: BuildingView },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/sites/:siteId/buildings/:buildingId/edit",
      name: "Edit Building",
      components: { default: EditBuilding },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/sites/:siteId/buildings/:buildingId/add-plant",
      name: "Add Plant",
      components: { default: AddPlant },
      beforeEnter: authGuard
    },
    {
      path: ":clientId/sites/:siteId/buildings/:buildingId/plants/:plantId",
      name: "Plant",
      components: { default: PlantView },
      beforeEnter: authGuard
    },
    {
      path:
        ":clientId/sites/:siteId/buildings/:buildingId/plants/:plantId/edit",
      name: "Edit Plant",
      components: { default: EditPlant },
      beforeEnter: authGuard
    }
  ]
};

let statInspRoutes = {
  path: "/stat-insp",
  component: DashboardLayout,
  name: "Stat-Insp Section",
  redirect: "stat-insp-list",
  children: [
    {
      path: "plants-without-stat-insps",
      name: "Plants without Stat. Insp.",
      components: { default: PlantsWithoutStatInsps },
      beforeEnter: authGuard
    },
    {
      path: "stat-insp-list",
      name: "List Statutory Inspections",
      components: { default: StatInspByFilter },
      beforeEnter: authGuard
    },
    {
      path: "stat-insp-items-filter",
      name: "Stat Insp Items Filter",
      components: { default: StatInspItemFilter },
      props: route => ({
        typeId: route.query.typeId,
        statusId: route.query.statusId
      }),
      beforeEnter: authGuard
    },
    {
      path: "create-stat-insp/:plantId",
      name: "Create Statutory Inspection",
      components: { default: AddStatInsp },
      beforeEnter: authGuard
    },
    {
      path: ":statInspId",
      name: "Statutory Inspection",
      components: { default: StatInspView },
      beforeEnter: authGuard
    },
    {
      path: ":statInspId/edit",
      name: "Edit Statutory Inspection",
      components: { default: EditStatInsp },
      beforeEnter: authGuard
    },
    {
      path: "create-next-report/:statInspId",
      name: "Create Next Statutory Inspection",
      components: { default: NextStatInsp },
      beforeEnter: authGuard
    },
    {
      path: ":statInspId/create-stat-insp-item",
      name: "Create Stat Insp Item",
      components: { default: AddStatInspItem },
      beforeEnter: authGuard
    },
    {
      path: ":statInspId/item/:statInspItemId",
      name: "Stat Insp Item View",
      components: { default: StatInspItemView },
      beforeEnter: authGuard
    },
    {
      path: ":statInspId/item/:statInspItemId/edit",
      name: "Edit Stat Insp Item",
      components: { default: EditStatInspItem },
      beforeEnter: authGuard
    }
  ]
};

let quoteRoutes = {
  path: "/quotes",
  component: DashboardLayout,
  name: "Quotes Section",
  redirect: "Quotes",
  children: [
    {
      path: "live",
      name: "Live Quotes",
      components: { default: QuotesList },
      props: route => ({
        clientId: route.query.clientId,
        contractorRegionId: route.query.contractorRegionId,
        statusId: route.query.statusId
      }),
      beforeEnter: authGuard
    },
    {
      path: "completed",
      name: "Completed Quotes",
      components: { default: QuotesCompletedList },
      beforeEnter: authGuard
    },
    {
      path: "rejected",
      name: "Rejected Quotes",
      components: { default: QuotesRejectedList },
      beforeEnter: authGuard
    },
    {
      path: "add-quote",
      name: "Add Quote",
      components: { default: AddQuote },
      beforeEnter: authGuard
    },
    {
      path: ":quoteId/edit",
      name: "Edit Quote",
      components: { default: EditQuote },
      beforeEnter: authGuard
    },
    {
      path: ":quoteId/reissue",
      name: "Reissue Quote",
      components: { default: ReissueQuote },
      beforeEnter: authGuard
    },
    {
      path: ":quoteId",
      name: "Quote",
      components: { default: QuoteView },
      beforeEnter: authGuard
    }
  ]
};

let portfolioRoutes = {
  path: "/portfolio",
  component: DashboardLayout,
  name: "Portfolio",
  redirect: "Clients",
  children: [
    {
      path: "clients",
      name: "Portolio Clients",
      components: { default: ClientListing },
      beforeEnter: authGuard
    },
    {
      path: "clientId=:clientId",
      name: "Client Details",
      components: { default: Client },
      beforeEnter: authGuard
    },
    {
      path: "siteId=:siteId",
      name: "Site Details",
      components: { default: Site },
      beforeEnter: authGuard
    },
    {
      path: "buildingId=:buildingId",
      name: "Building Details",
      components: { default: Building },
      beforeEnter: authGuard
    },
    {
      path: "plantId=:plantId",
      name: "Plant Details",
      components: { default: Plant },
      beforeEnter: authGuard
    }
  ]
};

let usersRoutes = {
  path: "/userManagement",
  component: DashboardLayout,
  name: "User Management Section",
  redirect: "Users",
  children: [
    {
      path: "",
      name: "Users",
      components: { default: UserListings },
      beforeEnter: authGuard
    },
    {
      path: "add-user",
      name: "Add User",
      components: { default: AddUser },
      beforeEnter: authGuard
    },
    {
      path: ":emailAddress/edit",
      name: "Edit User",
      components: { default: EditUser },
      beforeEnter: authGuard
    }
  ]
};

const router = new Router({
  // Assumes we being served via something "SPA aware" with index.html redirects
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      redirect: "Landing"
    },
    consultantRoutes,
    contractorRoutes,
    clientRoutes,
    statInspRoutes,
    quoteRoutes,
    portfolioRoutes,
    usersRoutes,
    {
      path: "/",
      component: DashboardLayout,
      children: [
        {
          path: "landing",
          name: "Landing",
          components: { default: Landing },
          beforeEnter: authGuard
        },
        {
          path: "dashboard",
          name: "Dashboard",
          components: { default: Dashboard },
          beforeEnter: authGuard
        }
      ]
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
